export default __webpack_public_path__ + "static/Mountain-d3c19717e8201bd12811f8065bfe85bf.webp";